const TYPING_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

/**
 * Whether a key event happened while typing (a text field or rich text editor), so page-wide
 * shortcuts leave it alone. Checked by shape rather than `instanceof`, so it runs in Jest too.
 */
export function isTypingTarget(event: { target: EventTarget | null }): boolean {
  const target = event.target as { isContentEditable?: boolean; tagName?: unknown } | null;
  if (!target) return false;
  if (target.isContentEditable === true) return true;
  return typeof target.tagName === 'string' && TYPING_TAGS.has(target.tagName.toUpperCase());
}
